<div class="vo-central-content">
  <div class="heading-image mb-30"></div>

  <div
    class="align-items-center login-extended-functionality-container d-flex flex-column mx-auto"
    *ngIf="isValidationOtpForm"
  >
    <div
      *ngIf="hasExceededMaximumOtpSendLimit && (hasUserExceededMaximumOtpValidation || !hasAnOtpCodeActive); else isValidationFormDisplayed"
      class="vo-info-box--danger-top mb-30 w-100"
    >
      {{ referenceDataLabels.VerificationCodeHasExceededMaximumOtpSendLimit | localizeLabel }}
    </div>

    <ng-template #isValidationFormDisplayed>
      <div
        *ngIf="isOtpCodeInvalid && !hasUserExceededMaximumOtpValidation && hasAnOtpCodeActive"
        class="vo-info-box--danger-top mb-30 w-100"
      >
        {{ referenceDataLabels.VerificationCodeInvalidOtpInfo | localizeLabel }}
      </div>

      <div
        *ngIf="hasUserExceededMaximumOtpValidation && hasAnOtpCodeActive"
        class="vo-info-box--danger-top mb-30 w-100"
      >
        {{ referenceDataLabels.VerificationCodeHasExceededMaximumOtpValidation | localizeLabel }}
      </div>

      <div *ngIf="!hasAnOtpCodeActive" class="vo-info-box--danger-top mb-30 w-100">
        {{ referenceDataLabels.VerificationCodeHasExpired | localizeLabel }}
      </div>

      <div
        class="vo-heading-bold-24 mb-30 text-center"
        [innerHTML]="referenceDataLabels.VerificationCodeTitle | localizeLabel"
      ></div>

      <div class="vo-body-regular-14 text-center mb-30">
        {{ referenceDataLabels.VerificationCodeInfoSent | localizeLabel }} {{ maskedPhoneNumber }}
      </div>

      <div class="w-100">
        <boi-text-input
          type="text"
          [labelName]="referenceDataLabels.VerificationCodeEnterInputLabel"
          [(ngModel)]="otpCode"
          [required]="true"
          cssClasses="label-top label-weight-bold"
          class="field-input-full-width mb-10 mt-0 field-text-center"
        >
        </boi-text-input>
      </div>

      <button
        class="vo-primary-button-1 w-100 mt-30"
        (click)="loginWithOtp()"
        [innerHTML]="referenceDataLabels.Continue | localizeLabel"
      ></button>

      <button
        [disabled]="hasExceededMaximumOtpSendLimit"
        class="vo-primary-button-2 w-100 mt-20"
        (click)="sendCode()"
        [innerHTML]="referenceDataLabels.VerificationCodeReSendButton | localizeLabel"
      ></button>
    </ng-template>

    <a class="vo-link d-flex justify-content-center mt-30" (click)="onBackToLogin()"
      >{{ referenceDataLabels.BackToLoginButton | localizeLabel }}</a
    >
  </div>

  <form
    *ngIf="!isValidationOtpForm"
    method="POST"
    class="align-items-center login-extended-functionality-container d-flex flex-column mx-auto"
    (ngSubmit)="login(loginForm)"
    #loginForm="ngForm"
  >
    <div *ngIf="errorMessage" class="vo-info-box--danger-top mb-15 w-100">{{errorMessage}}</div>

    <div
      *ngIf="notificationType === registrationConfirmationStatus.CONFIRMED_EMAIL_UPDATE"
      class="vo-info-box--success mb-15"
    >
      <div class="vo-heading-bold-20">
        {{referenceDataLabels.EmailUpdateConfirmationSuccessfulSubtitle | localizeLabel }}
      </div>
      <div class="vo-body-regular my-15">
        {{referenceDataLabels.EmailUpdateConfirmationSuccessfulIntroduction | localizeLabel }}
      </div>
    </div>

    <div *ngIf="notificationType === registrationConfirmationStatus.INVALID" class="vo-info-box--danger-top mb-15">
      <div class="vo-heading-bold-20">{{referenceDataLabels.InvalidLink | localizeLabel }}</div>
      <div class="vo-body-regular my-15">{{referenceDataLabels.InvalidEmailConfirmationRequest | localizeLabel }}</div>
    </div>

    <div
      class="vo-heading-bold-24 mb-30 text-primary-color"
      [innerHTML]="referenceDataLabels.LoginSubtitle | localizeLabel"
    ></div>

    <div
      class="vo-body-regular-14 text-center my-15 w-100"
      [ngClass]="{'has-errors': loginForm.submitted && (usernameInput.hasError('required') || usernameInput.hasError('email'))}"
    >
      <div
        class="error-message"
        *ngIf="loginForm.submitted && usernameInput.hasError('required')"
        [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage:'LoginUsername'"
      ></div>

      <div
        class="error-message"
        *ngIf="loginForm.submitted && usernameInput.hasError('email')"
        [innerHTML]="referenceDataConstants.ERROR_MESSAGE_AE000 | localizeErrorMessage:'Email'"
      ></div>

      <boi-text-input
        class="field-input-full-width field-text-center"
        #usernameInput="ngModel"
        [labelName]="referenceDataLabels.Email"
        [(ngModel)]="username"
        email="true"
        [required]="true"
        [forceRequired]="true"
        cssClasses="label-top"
        name="username"
      >
      </boi-text-input>
    </div>

    <div
      class="vo-body-regular-14 text-center my-15 w-100"
      [ngClass]="{'has-errors': loginForm.submitted && passwordInput.hasError('required')}"
    >
      <div
        class="error-message mb-15"
        *ngIf="loginForm.submitted && passwordInput.hasError('required')"
        [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage:'LoginPassword'"
      ></div>

      <boi-text-input
        class="field-input-full-width field-text-center"
        #passwordInput="ngModel"
        [type]="'password'"
        [labelName]="referenceDataLabels.Password"
        [(ngModel)]="password"
        [required]="true"
        cssClasses="label-top"
        [canShowPassword]="true"
        name="password"
      >
      </boi-text-input>
    </div>

    <button
      id="gtag-login"
      class="vo-primary-button-1 my-30 w-100"
      type="submit"
      [innerHTML]="referenceDataLabels.LoginButton|localizeLabel"
    ></button>

    <a
      class="vo-link text-center mb-30 fs-14"
      (click)="goToForgotPassword()"
      [innerHTML]="referenceDataLabels.ForgotPassword|localizeLabel"
    ></a>

    <div class="vo-body-regular-13 text-center mb-30" [innerHTML]="referenceDataLabels.BoiInfo|localizeLabel"></div>
  </form>
</div>
